import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseAnprData } from 'shell/models/person';
import { AnprVM } from 'shell/view-models/search-anpr';
import { UpdateParenthoodVM } from 'mutation/view-models/update-parenthood';
import { transformFamilyMember } from 'shell/utils/transform-family-members';

export const transformFamilyMembers = (
  httpResponse: AxiosResponse<HttpResponse<ResponseAnprData>>
): AnprVM<UpdateParenthoodVM> => {
  const data = httpResponse.data.payload?.risposta3002OK?.listaSoggetti?.datiSoggetto || [];

  const familyMembers: Array<UpdateParenthoodVM> = data.map((item) => {
    const transformedMember = transformFamilyMember(item);

    return {
      ...transformedMember,
      generality: item.generalita,
      linkSubject: item.legameSoggetto,
      family: item.famigliaConvivenza,
      relationship: item.legameSoggetto?.codiceLegame || '',
      relationshipOld: item.legameSoggetto?.codiceLegame || '',
    };
  });

  return {
    warnings: (httpResponse.data.payload?.risposta3002OK?.listaAnomalie?.errore || []).map(
      (warning) => ({
        id: warning.codiceErroreAnomalia,
        value: warning.testoErroreAnomalia,
      })
    ),
    errors: (httpResponse.data.payload?.rispostaKO?.listaErrori?.errore || []).map((error) => ({
      id: error.codiceErroreAnomalia,
      value: error.testoErroreAnomalia,
    })),
    persons: familyMembers,
  };
};
